// Date ANCPI - județe și UAT-uri (extrase direct din portal ANCPI - 100% acuratețe bot)
// Actualizat: decembrie 2024

import ancpiDataRaw from './ancpiData.json';

export const ANCPI_DATA = ancpiDataRaw;
